<template>
	<goal-settings-content
		widget-type="gift-goal"
		entity-name="dono goal"
		count-field="amount"
		number-type="float"
		round-count-on-load
		ignore-subscription-error
		@loading="$emit('loading', $event)"
	/>
</template>

<script>
import GoalSettingsContent from '@/components/Widget/GoalSettingsContent.vue';

export default {
	components: { GoalSettingsContent },
};
</script>
